import { isBusinessStreamPage } from "../../pages/BusinessStreamPage/businessStreamPage.utils";
import {
  isArticlePage,
  isArticlePageIndustryPerpectives,
  isCenteredSectionPage,
  isCoursePage,
  isPortNewsPage,
  isSectionPage,
  isSimpleEventPage,
  isSolutionPage,
  isTeasedNewsPage,
} from "../../types/optimizely/blocks";
import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";
import { TeaserCardProps } from "../TeaserCard/TeaserCard";

export const MapToTeaserCardProps = (
  item: OptimizelyExpandedValue
): TeaserCardProps => {
  if (isTeasedNewsPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isArticlePageIndustryPerpectives(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isSimpleEventPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isSectionPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isCenteredSectionPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isSolutionPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isCoursePage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isBusinessStreamPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isArticlePage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  if (isPortNewsPage(item)) {
    return {
      title: item.name,
      tag: item.teaserHideTag?.value ? "" : item.organization?.value[0]?.name,
      image: item.mainImage?.expandedValue?.url || item.listImage?.expandedValue?.url,
      hideImage: item.teaserHideImage?.value,
      backgroundColor: item.teaserBackgroundColor?.value || "primary",
      created: item.created,
      href: item.url,
    };
  }
  return null;
};
